import Link from '@platform-ui/link';
import { TuiIconTdsIllustrationsCommonErrorRedLight } from '@tui-react/proprietary-icons';
import React from 'react';
import { FormattedMessage as Message } from 'react-intl';
import { SYSTEM_SCREEN } from 'schema/src/types/poll.generated';
import { resolveLinkUrl } from 'src/utils/location';
import intl from '../../locale';
import ImageComponent from '../Image';
import { NewOverlay } from '../NewOverlay';
import styles from './NewConfigurationErrorOverlay.module.css';

export const NewConfigurationErrorOverlay: React.FC<{
  isWebview: boolean;
  onClose: VoidFunction;
  overrideData?: SYSTEM_SCREEN;
}> = ({ isWebview, onClose, overrideData }) => {
  const data = overrideData?.data;

  const icon = data?.image?.src ? (
    <ImageComponent image={data.image} />
  ) : (
    <TuiIconTdsIllustrationsCommonErrorRedLight iconSize={160} />
  );

  const ctaUrl = resolveLinkUrl(data?.ctaUrl);
  const ctaButton = data?.cta && ctaUrl ? { text: data.cta, href: ctaUrl } : undefined;

  const title = data?.title || intl.formatMessage({ id: 'System.NewConfigurationErrorTitle' });

  const description = data?.text || (
    <span className={styles.info}>
      {intl.formatMessage({ id: 'System.NewConfigurationErrorDescriptionP1' })}

      {window.POLL_ERROR_URL && window.POLL_ERROR_TEXT && (
        <>
          <br />
          <Message id={'System.NewConfigurationErrorDescriptionP2'} />
          <Link href={window.POLL_ERROR_URL}>{window.POLL_ERROR_TEXT}</Link>
        </>
      )}
    </span>
  );

  return (
    <NewOverlay
      onClose={onClose}
      isWebview={isWebview}
      icon={icon}
      alignContent={data?.alignContent}
      ctaButton={ctaButton}
      title={title}
      description={description}
    />
  );
};
